import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box, Card, Link, Typography, Stack, Grid, Button, Container, Tab, Tabs } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import AuthService from '../../../services/auth_service'

const useStyles = styled((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const UserChangePasswordForm = ({ user }) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [message, setMessage] = useState('')
    // const { user } = props;
    const [form, setForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });


    const onSubmit = (event) => {
        event.preventDefault();

        if (form.newPassword !== form.confirmPassword) {
            return;
        }
        AuthService.changePassword(form.currentPassword,
            form.newPassword,
            form.confirmPassword)
            .then((data) => setMessage(data['detail']))
            .catch((error) => {
                if (error.response) {

                }
            })

    };

    const handleChange = (event) => {
        setForm({
            ...form,
            [event.target.id]: event.target.value,
        });
    };

    return (


        <form className={classes.root} noValidate autoComplete="off">
            <Grid container spacing={4} >
                <Grid item xs={12} sm={12} md={12}>
                    <TextField
                        label="Current password"
                        type="password"
                        name="currentPassword"
                        id="currentPassword"
                        required
                        value={form.currentPassword}
                        onChange={handleChange}
                    // error={!!form.currentPassword}
                    // helperText={form.currentPassword && 'Обязательное поле'}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <TextField
                        label="New password"
                        type="password"
                        name="newPassword"
                        id="newPassword"
                        value={form.newPassword}
                        onChange={handleChange}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <TextField
                        label="Confirm new password"
                        id="confirmPassword"
                        type="password"
                        name="confirmPassword"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        required
                        error={form.newPassword !== '' && form.newPassword !== form.confirmPassword}
                        helperText={form.newPassword !== '' && form.newPassword !== form.confirmPassword && 'Passwords do not match'}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <Button onClick={onSubmit} variant="contained" color="primary">
                        Change password
                    </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    {message}
                </Grid>
            </Grid>
        </form >

    );
}
export default UserChangePasswordForm;